export default "__VITE_ASSET__a19d5f72__"